import { ZERO_RADIUS } from "../domain/create-shared";
import {
  bandBorderAfterWidthChange,
  bandBorderHasVisibleWidth,
  defaultSurfaceBorder,
} from "../operations/emailBuilderBandBorder";
import type { BorderStyle, CornerRadius, Padding } from "../domain/types";

export const SURFACE_PADDING_ADD_DEFAULT: Padding = {
  top: 24,
  right: 24,
  bottom: 24,
  left: 24,
};

export const SURFACE_CORNER_ROUNDING_ADD_DEFAULT = 8;

export function isPaddingInactive(padding: Padding): boolean {
  return (
    padding.top === 0 &&
    padding.right === 0 &&
    padding.bottom === 0 &&
    padding.left === 0
  );
}

export function surfacePaddingAddDefault(): Padding {
  return { ...SURFACE_PADDING_ADD_DEFAULT };
}

export function isCornerRoundingInactive(radius: CornerRadius | undefined): boolean {
  const value = radius ?? ZERO_RADIUS;
  return (
    value.topLeft === 0 &&
    value.topRight === 0 &&
    value.bottomRight === 0 &&
    value.bottomLeft === 0
  );
}

export function surfaceCornerRoundingAddDefault(): CornerRadius {
  const radius = SURFACE_CORNER_ROUNDING_ADD_DEFAULT;
  return {
    topLeft: radius,
    topRight: radius,
    bottomRight: radius,
    bottomLeft: radius,
  };
}

export function isSurfaceBackgroundInactive(
  backgroundColor: string,
  backgroundImage?: string,
): boolean {
  const hasImage = Boolean(backgroundImage && backgroundImage.length > 0);
  return (backgroundColor === "transparent" || backgroundColor === "") && !hasImage;
}

export function isSurfaceBorderInactive(border: BorderStyle): boolean {
  return !bandBorderHasVisibleWidth(border.width) || border.style === "none";
}

export function surfaceBorderAddDefault(): BorderStyle {
  return bandBorderAfterWidthChange(
    {
      ...defaultSurfaceBorder(),
      style: "solid",
    },
    { top: 1, right: 1, bottom: 1, left: 1 },
  );
}

export const BUTTON_BORDER_ADD_WIDTH = 1;

export function isButtonBorderInactive(borderWidth: number): boolean {
  return borderWidth <= 0;
}

export function buttonBorderAddDefault(): { borderWidth: number } {
  return { borderWidth: BUTTON_BORDER_ADD_WIDTH };
}

export type EmailBuilderSettingsSectionActivation =
  | { mode: "always" }
  | {
      mode: "optional";
      isActive: boolean;
      onAdd: () => void;
    };
